module.exports = __webpack_public_path__ + "img/matanot_no.e7cf824a.png";